export const initSlider = (selector, config) => {
    const $el = window.jQuery(selector);
    $el.slick(config);
    return $el;
};

export const getSliderItemValue = (sliderItem) => {
    const imgEl = sliderItem.querySelector('img');

    if (imgEl?.alt) {
        return imgEl.alt;
    }
};

export const removeLoading = (selector) => {
    const wrapper = document.querySelector(selector);

    if (wrapper && wrapper.classList.contains('lp-loading')) {
        wrapper.classList.remove('lp-loading');
    }
};

export const visibilityItem = (selector) => {
    const wrapper = document.querySelector(selector);
    const items = wrapper ? wrapper.children : [];

    if (items.length > 0) {
        const currentDate = new Date();

        Array.from(items).forEach((el) => {
            const dateShowItem = parseDateFormat(
                el.getAttribute('data-item-start')
            );
            const dateHideItem = parseDateFormat(
                el.getAttribute('data-item-end')
            );

            if (dateShowItem || dateHideItem) {
                if (currentDate < dateShowItem || currentDate > dateHideItem) {
                    el.remove();
                }
            }
        });
    }
};

export const parseDateFormat = (date) => {
    const dateParts = date.split(/[\s/,:]+/);

    return new Date(
        dateParts[2],
        dateParts[1] - 1,
        dateParts[0],
        dateParts[3],
        dateParts[4]
    );
};

export const destroySlider = (element) => {
    element.slick('unslick');
};
